import {
  route,
} from '@app/Routing/helpers'
import { accessPermission } from '@access/permissions'

import {
  KEYCRM_TOKEN,
  ALL,
} from '@app/Seller/accessTokens'

const Base = () => import('@app/Seller/Components/Base')

const KeyCrmBase = () => import('@app/Seller/KeyCrm/Base')
const KeyCrmSettings = () => import('@app/Seller/KeyCrm/Tabs/Settings')
const KeyCrmDeliveryMethods = () => import('@app/Seller/KeyCrm/Tabs/DeliveryMethods')
const KeyCrmPaymentMethods = () => import('@app/Seller/KeyCrm/Tabs/PaymentMethods')
const KeyCrmWebhook = () => import('@app/Seller/KeyCrm/Tabs/Webhook')
const KeyCrmAdditional = () => import('@app/Seller/KeyCrm/Tabs/Additional')

const ModulesLiqpay = () => import('@app/Seller/Modules/Liqpay/View')

const ModulesNewPostView = () => import('@app/Seller/Modules/Novaposhta/View')
const ModulesNovaposhtaList = () => import('@app/Seller/Modules/Novaposhta/List')
const ModulesNovaposhtaSettings = () => import('@app/Seller/Modules/Novaposhta/Settings')
const ModulesNovaposhtaAdd = () => import('@app/Seller/Modules/Novaposhta/Add')

const MODEL = 'integrations'
const BASE = `${MODEL}/`

export const INTEGRATIONS_PREFIX = `${MODEL}:`
const p = name => INTEGRATIONS_PREFIX + name

export const INTEGRATIONS_BASE_NAME = p('base')

export const KEY_CRM_PREFIX = 'key-crm:'
const kp = name => KEY_CRM_PREFIX + name

export const KEY_CRM_BASE_NAME = kp('base')
export const KEY_CRM_SETTINGS_NAME = kp('settings')
export const KEY_CRM_DELIVERY_NAME = kp('delivery')
export const KEY_CRM_PAYMENT_NAME = kp('payment')
export const KEY_CRM_WEBHOOK_NAME = kp('webhook')
export const KEY_CRM_ADDITIONAL_NAME = kp('additional')

export const INTEGRATIONS_LIQPAY_NAME = p('liqpay')

const INTEGRATIONS_NOVAPOSHTA_PREFIX = p('novaposhta:')
export const INTEGRATIONS_NOVAPOSHTA_NAME = `${INTEGRATIONS_NOVAPOSHTA_PREFIX}init`
export const INTEGRATIONS_NOVAPOSHTA_LIST_NAME = `${INTEGRATIONS_NOVAPOSHTA_PREFIX}list`
export const INTEGRATIONS_NOVAPOSHTA_SETTINGS_NAME = `${INTEGRATIONS_NOVAPOSHTA_PREFIX}settings`
export const INTEGRATIONS_NOVAPOSHTA_ADD_NAME = `${INTEGRATIONS_NOVAPOSHTA_PREFIX}add`

export function createRoutes(options) {
  return [
    route(BASE, Base, INTEGRATIONS_BASE_NAME, {
      meta: accessPermission(ALL, options),
      redirect: { name: KEY_CRM_BASE_NAME },
      children: [
        route('key-crm/', KeyCrmBase, KEY_CRM_BASE_NAME, {
          meta: accessPermission(KEYCRM_TOKEN, options),
          redirect: { name: KEY_CRM_SETTINGS_NAME },
          children: [
            route('', KeyCrmSettings, KEY_CRM_SETTINGS_NAME, {
              meta: accessPermission(KEYCRM_TOKEN, options),
            }),
            route('delivery/', KeyCrmDeliveryMethods, KEY_CRM_DELIVERY_NAME, {
              meta: accessPermission(KEYCRM_TOKEN, options),
            }),
            route('payment/', KeyCrmPaymentMethods, KEY_CRM_PAYMENT_NAME, {
              meta: accessPermission(KEYCRM_TOKEN, options),
            }),
            route('webhook/', KeyCrmWebhook, KEY_CRM_WEBHOOK_NAME, {
              meta: accessPermission(KEYCRM_TOKEN, options),
            }),
            route('additional/', KeyCrmAdditional, KEY_CRM_ADDITIONAL_NAME, {
              meta: accessPermission(KEYCRM_TOKEN, options),
            }),
          ],
        }),
        route('liqpay/', ModulesLiqpay, INTEGRATIONS_LIQPAY_NAME, {
          meta: accessPermission(ALL, options),
        }),
        route('novaposhta/', ModulesNewPostView, INTEGRATIONS_NOVAPOSHTA_NAME, {
          meta: accessPermission(ALL, options),
          redirect: { name: INTEGRATIONS_NOVAPOSHTA_LIST_NAME },
          children: [
            route('list/', ModulesNovaposhtaList, INTEGRATIONS_NOVAPOSHTA_LIST_NAME, {
              meta: accessPermission(ALL, options),
            }),
            route('settings/', ModulesNovaposhtaSettings, INTEGRATIONS_NOVAPOSHTA_SETTINGS_NAME, {
              meta: accessPermission(ALL, options),
            }),
            route('add/', ModulesNovaposhtaAdd, INTEGRATIONS_NOVAPOSHTA_ADD_NAME, {
              meta: accessPermission(ALL, options),
            }),
          ],
        }),
      ],
    }),
  ]
}